import gql from 'graphql-tag';

export default gql`
  query availableLeadCount($input: AvailableLeadCountInput!) {
    availableLeadCount(input: $input) {
      total
    }
  }
`;
